export function DefaultTimeline() {
  return (
    <div className="w-[32rem]">
      <ul className="flex w-full flex-col">
        <li className="relative flex flex-col gap-2">
          <span className="absolute left-0 grid justify-center bg-transparent transition-opacity duration-200">
            <span className="h-full w-0.5 bg-blue-gray-100"></span>
          </span>
          <div className="flex h-3 items-center gap-4">
            <span className="relative z-[2] w-max flex-shrink-0 overflow-hidden rounded-full bg-gray-900 p-1.5 text-white"></span>
            <h6 className="block font-sans text-base font-semibold leading-none tracking-normal text-blue-gray-900 antialiased">
              Timeline Title Here.
            </h6>
          </div>
          <div className="flex gap-4 pb-8">
            <span className="pointer-events-none invisible h-full flex-shrink-0"></span>
            <div>
              <p className="block font-sans text-sm font-normal leading-normal text-gray-600 antialiased">
                The key to more success is to have a lot of pillows. Put it this
                way, it took me twenty five years to get these plants, twenty
                five years of blood sweat and tears, and I&apos;m never giving
                up, I&apos;m just getting started. I&apos;m up to something. Fan
                luv.
              </p>
            </div>
          </div>
        </li>
        <li className="relative flex flex-col gap-2">
          <span className="absolute left-0 grid justify-center bg-transparent transition-opacity duration-200">
            <span className="h-full w-0.5 bg-blue-gray-100"></span>
          </span>
          <div className="flex h-3 items-center gap-4">
            <span className="relative z-[2] w-max flex-shrink-0 overflow-hidden rounded-full bg-gray-900 p-1.5 text-white"></span>
            <h6 className="block font-sans text-base font-semibold leading-none tracking-normal text-blue-gray-900 antialiased">
              Timeline Title Here.
            </h6>
          </div>
          <div className="flex gap-4 pb-8">
            <span className="pointer-events-none invisible h-full flex-shrink-0"></span>
            <div>
              <p className="block font-sans text-sm font-normal leading-normal text-gray-600 antialiased">
                The key to more success is to have a lot of pillows. Put it this
                way, it took me twenty five years to get these plants, twenty
                five years of blood sweat and tears, and I&apos;m never giving
                up, I&apos;m just getting started. I&apos;m up to something. Fan
                luv.
              </p>
            </div>
          </div>
        </li>
        <li className="relative flex flex-col gap-2">
          <div className="flex h-3 items-center gap-4">
            <span className="relative z-[2] w-max flex-shrink-0 overflow-hidden rounded-full bg-gray-900 p-1.5 text-white"></span>
            <h6 className="block font-sans text-base font-semibold leading-none tracking-normal text-blue-gray-900 antialiased">
              Timeline Title Here.
            </h6>
          </div>
          <div className="flex gap-4">
            <span className="pointer-events-none invisible h-full flex-shrink-0"></span>
            <div>
              <p className="block font-sans text-sm font-normal leading-normal text-gray-600 antialiased">
                The key to more success is to have a lot of pillows. Put it this
                way, it took me twenty five years to get these plants, twenty
                five years of blood sweat and tears, and I&apos;m never giving
                up, I&apos;m just getting started. I&apos;m up to something. Fan
                luv.
              </p>
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
}
